import {
	FormsActionTypes,
	FormsEntities,
	FormsHelpers,
	FormsPayloadEntities,
	IDmData,
	MessageBox,
	Mobile,
	ServiceList
} from '@bimser/common';
import {
	BCAlert,
	BCErrorView,
	BCLayoutCreator,
	BCNotification,
	BCScrollbarRef,
	IAlertTypes,
	findMessage
} from '@bimser/components';
import { ViewerHelpers } from '@bimser/components/dist/BCLayoutCreator';
import * as LayoutCreatorEntities from '@bimser/components/dist/BCLayoutCreator/common/entities';
import * as LayoutCreatorBuilderEntities from '@bimser/components/dist/BCLayoutCreator/environment/builder/entities';
import { IRuleType } from '@bimser/components/dist/BCRuleManager';
import {
	EDeviceTypes,
	FormItemTypes,
	IDictionary,
	ILanguage,
	MLHelper,
	RxEventEmitter,
	createGuid,
	debounce,
	getDeviceType,
	isNullOrUndefined,
	mobile
} from '@bimser/core';
import { ServiceHelper } from '@bimser/studio-core';
import { List, Map } from 'immutable';
import cloneDeep from 'lodash/cloneDeep';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _isEqual from 'lodash/isEqual';
import _set from 'lodash/set';
import throttle from 'lodash/throttle';
import _uniqWith from 'lodash/uniqWith';
import React, { JSX } from 'react';
import ReactToPrint from 'react-to-print';
import { Subscription } from 'rxjs';
import { EventArgs, FormView, Mirror, RelatedDocuments, UserMetadata } from '../..';
import { Common, IFlowDisplayMode } from '../../../../entities';
import {
	FormType,
	IDataSource,
	IDocumentStatus,
	IEventItem,
	IFormPublicField,
	IPropertyField,
	IUserSession,
	IVariableItem,
	SizeType
} from '../../../../entities/common';
import { ParentWindowType, WindowType } from '../../../../entities/common/Types';
import {
	ExecuteActionTypes,
	ICreateFormArgs,
	IOpenFormArgs,
	IOpenProcessArgs,
	IOpenSelectionFormArgs,
	IStartAProcessArgs
} from '../../../../entities/common/executeActionArgs';
import { IExecuteActionArgs } from '../../../../entities/common/executeActionArgs/IExecuteActionArgs';
import { IUserEvent } from '../../../../entities/services';
import {
	FormSharedVariables,
	deepMergeFormItems,
	getTriggeredRules,
	geti18nValue,
	isDMSecretModified,
	mergeDataAndView,
	normalizeItemsForServer,
	setPanelChildren
} from '../../../../helper';
import { CreateForm, RunEvent } from '../../../../services';
import GetRelatedDocumentObjects from '../../../../services/getRelatedDocumentObjects';
import { SaveAsDraft } from '../../../../services/saveAsDraft';
import FormItemManager from '../../FormItemManager';
import Control from '../../base/Control';
import { FormBindedHelpers } from '../../base/FormBindedHelpers';
import LayoutControl from '../../base/LayoutControl';
import VisualControl from '../../base/VisualControl';
import {
	IBeforeCommitEventArgs,
	IBeforeSaveEventArgs,
	IControlExecutedServerEvent,
	IEventActionEventArgs,
	IPropertyChangedEventArgs,
	IToolbarButtonClickEventArgs,
	IUnloadEventArgs
} from '../../entities/EventArgs';
import { IBeforeSaveAsEventArgs } from '../../entities/EventArgs/IBeforeSaveAsEventArgs';
import { IControlProperties } from '../../entities/IControlProperties';
import { getCultureEnumMembers, getValueControl, proxyCreator } from '../../helper';
import FileSelector from '../FileSelector';
import IFile from '../FileSelector/entities/IFile';
import { IRelatedDocumentCategory, IRelatedDocumentFile } from '../RelatedDocuments/entities';
import { ControlComponent } from './components/ControlComponent';
import { SummaryMessages } from './components/SummaryMessages';
import {
	IFastApproveArgs,
	IFormProperties,
	IFormToolbarButton,
	IFormToolbarPrintButton,
	IOnShowMessageOptions,
	IOpenApplicationItemArgs,
	IRuleTriggerEventItem,
	IRunTaskResponse,
	ITransaction
} from './entities';

export default class Form extends FormBindedHelpers {
	controlMap: IDictionary<Control> = {};

	private rdObjectLoadedForView: string = null;
	private layoutCreatorRefs = React.createRef<{
		container: HTMLDivElement;
		scrollView: BCScrollbarRef;
	}>();

	isFirstLoad: boolean;
	isLoadingRDObjects = false;
	controls: Array<Control>;
	items: Map<string, LayoutCreatorEntities.LayoutDataItem> = Map();
	view: LayoutCreatorEntities.NormalizedLayoutStructureItems =
		LayoutCreatorEntities.NormalizedLayoutStructureItemsFactory();
	windowSize: LayoutCreatorEntities.WindowSize = undefined;
	formName: string;
	projectName: string;
	supportedLanguages?: Array<ILanguage>;
	currentLanguage?: ILanguage;
	documentId: number;
	versioningEnabled: boolean;
	text: IDictionary<string>;
	formType: FormType;
	sizeType: SizeType;
	paddingType: SizeType;
	statuses: IDocumentStatus[];
	identityFormat: string;
	identityFormatId: number;
	copyPasteEnabled: boolean;
	publicFields: IFormPublicField[];
	rules: IDictionary<IRuleType>;
	session: IUserSession;
	responseParameters: IDictionary<any>;
	toolbarButtons: IFormToolbarButton[];
	displayMode: IFlowDisplayMode;
	parentWindowType: ParentWindowType;
	openOn: WindowType;
	canSaveAsDraft: boolean;
	flowSecretKey: string;
	draftSecretKey: string;
	rxInternalSubscription: Subscription = null;
	rxExternalSubscription: Subscription = null;
	childForms: Common.IChildForm[] = [];
	runSecretKey: string;
	summaryMessages: List<FormsEntities.SummaryMessage> = List();
	activeView: string;
	createSecretKey: string;
	secretKey: string;
	relatedControlId: string;
	executeActionType: ExecuteActionTypes;
	isDataEntryForm: boolean;
	packageVersion: number;
	passKey?: string;

	__executedServerEvent: IControlExecutedServerEvent;
	__formViewerControlType: string = '';
	__formViewerControlName: string = '';
	__formViewerFormId: string = '';
	__formViewerViewName: string = '';
	__windowId: string;
	__parentFormId: string;
	__mobileFormView: Mobile.MobileFormView;
	__validateModalForm: boolean = true;
	__fromMobile: boolean;
	__isFlowEventForm: boolean;
	__forceRender: string[] = [];
	__currentFormCaption: string = '';
	__transactionId: string;
	__sentTransactions: string[] = [];
	__transactions: IDictionary<ITransaction>;
	__readOnlyFlag: boolean;
	__openedModalList: string[] = [];
	__printRef: ReactToPrint;
	__hasScrollbar: boolean = true;
	__keepPanelOpen: boolean = false;
	__formError;
	__shadowDomMode: boolean = false;
	__interactionHelper: any;
	private __serverFormDomRef = React.createRef<FormView>();
	private __serverPrintRef = React.createRef<ReactToPrint>();

	fastApprove: (args: IFastApproveArgs) => Promise<void>;

	__formItemsLoaded: (args: LayoutCreatorEntities.IFormItemsLoadAction) => void;
	__getServerPrintFormProperties: () => any;
	__formCaptionTextChanged: (title: string) => void;
	__showLoading: () => void;
	__hideLoading: () => void;
	__closeWindowById: () => void;
	__getFormViewerData: (args: any) => void;
	__forceUpdate: (forceId: string) => void;
	__setFormViewerControls: () => void;
	__closeFormById: (id: string) => void;

	__onShowMessage: (type: 'Toaster' | 'MessageBox', options: IOnShowMessageOptions) => void;

	constructor() {
		super();

		this.caption.visible = false;
		this.controlType = FormItemTypes.EContainerTypes.Form;
		this.formType = 'standard';
		this.paddingType = 'middle';
		this.sizeType = 'middle';
		this.statuses = [];
		this.identityFormat = '';
		this.copyPasteEnabled = false;
		this.versioningEnabled = false;
		this.activeView = 'default';
		this.createSecretKey = null;
		this.secretKey = null;
		this.relatedControlId = null;
		this.style.backgroundColor = 'rgba(255, 255, 255, 0)';
		this.toolbarButtons = [];
		this.publicFields = [];
		this.canSaveAsDraft = false;
		this.flowSecretKey = null;
		this.controls = new Array();
		this.__transactions = {};

		this.__controlRenderManager = this.__controlRenderManager.bind(this);
		this.__isControlVisible = this.__isControlVisible.bind(this);
		this.__onLayoutDidUpdate = this.__onLayoutDidUpdate.bind(this);
		this.__createControl = this.__createControl.bind(this);
		this.__triggerPreRender = this.__triggerPreRender.bind(this);
		this.__onControlClick = this.__onControlClick.bind(this);
		this.__onControlDoubleClick = this.__onControlDoubleClick.bind(this);
		this.__checkRules = this.__checkRules.bind(this);
		this.__getRDObjects = this.__getRDObjects.bind(this);
		this.__runLoadProperties = this.__runLoadProperties.bind(this);
		this.__validate = this.__validate.bind(this);
		this.__subscribeClientEvents = this.__subscribeClientEvents.bind(this);
		this.__subscribeServerEvents = this.__subscribeServerEvents.bind(this);
		this.__reloadControlDataSource = this.__reloadControlDataSource.bind(this);
		this.__triggerOnLoadEvents = this.__triggerOnLoadEvents.bind(this);
		this.__beforePrint = this.__beforePrint.bind(this);
		this.__afterPrint = this.__afterPrint.bind(this);
		this.__onSummaryMessageClose = this.__onSummaryMessageClose.bind(this);
		this.__onFormScrollStart = debounce(this.__onFormScrollStart.bind(this), 100, true);
		this.__onFormResize = debounce(this.__onFormResize.bind(this), 400);
		this.__onToolbarButtonClicked = throttle(this.__onToolbarButtonClicked.bind(this), 500, {
			trailing: false
		});
		this.__runServerEvent = this.__runServerEvent.bind(this);
		this.__onAfterSaveAndContinue = this.__onAfterSaveAndContinue.bind(this);
		this.__OnEventActionEvent = this.__OnEventActionEvent.bind(this);
		this.__onEventButtonClicked = this.__onEventButtonClicked.bind(this);
		this.__handleToolbarButtonClick = this.__handleToolbarButtonClick.bind(this);
		this.sendDataEntryForm = this.sendDataEntryForm.bind(this);
		this.getMenuParameters = this.getMenuParameters.bind(this);
		this.openExternalLink = this.openExternalLink.bind(this);
		this.__afterServerPrint = this.__afterServerPrint.bind(this);
		this.__beforeServerPrint = this.__beforeServerPrint.bind(this);
		this.__printServerForm = this.__printServerForm.bind(this);
		this.__renderServerPrint = this.__renderServerPrint.bind(this);
		this.__getShadowRootContainer = this.__getShadowRootContainer.bind(this);
		this.__getShadowPopupContainer = this.__getShadowPopupContainer.bind(this);
		this.__getShadowRoot = this.__getShadowRoot.bind(this);
		this.__loadStyles = this.__loadStyles.bind(this);

		this.subscribe('event:RunServerEvent', this.__runServerEvent);
		this.subscribe('system:OnAfterSaveAndContinue', this.__onAfterSaveAndContinue);
		this.subscribe('system:OnEventActionEvent', this.__OnEventActionEvent);
		this.subscribe('system:OnEventButtonClicked', this.__onEventButtonClicked);
		this.subscribe('system:OnToolbarButtonClicked', this.__handleToolbarButtonClick);
	}

	__loadStyles(formName: string): HTMLStyleElement[] {
		return [];
	}

	override __onLoad(args?: Common.IOnLoadArgs): void {
		super.__onLoad(args);

		if (this.items) {
			const allUserMetadata = this.items.filter(control => {
				if (control.type === FormItemTypes.EControlTypes.UserMetadata) {
					const userMetadata = this.controlMap[control.id] as unknown as UserMetadata;

					if (userMetadata) {
						const isCustomType = userMetadata.metadataType === 'Custom';
						const hasMetadataName = userMetadata.customMetadataName !== '';

						return isCustomType && hasMetadataName;
					}
				}
			});

			if (allUserMetadata.count()) {
				this.getCustomMetadataList(allUserMetadata.keySeq().toList());
			}
		}
	}

	private getCustomMetadataList(allUserMetadata: List<string>) {
		ServiceHelper.getCustomMetadataName()
			.then(result => {
				allUserMetadata.forEach(userMetadataId => {
					const userMetadata = this.controlMap[userMetadataId] as unknown as UserMetadata;
					if (userMetadata) {
						userMetadata.__setCustomMetadataList(result.options);
					}
				});
			})
			.catch(error => {
				console.warn('An error occured when CustomMetadatas loading...', error);
			});
	}

	// Rx Event Helpers

	getShadowDomMode() {
		return this.__shadowDomMode;
	}

	getPanelId() {
		return this.__windowId;
	}

	getInternalEventName() {
		return `internal_${this.getPanelId()}`;
	}

	getExternalEventName(panelId?: string) {
		return `external_${panelId ? panelId : this.getPanelId()}`;
	}

	emitEventToAllChildren(data: EventArgs.IMessageReceivedEventArgs) {
		this.childForms.forEach(child => {
			RxEventEmitter.emit(this.getExternalEventName(child.windowId), data);
		});
	}

	emitEventToChildren(
		_filter: (child: Common.IChildForm, index: number) => boolean,
		data: EventArgs.IMessageReceivedEventArgs
	) {
		this.childForms.filter(_filter).forEach(child => {
			RxEventEmitter.emit(this.getExternalEventName(child.windowId), data);
		});
	}

	emitEventToParent(data: EventArgs.IMessageReceivedEventArgs) {
		if (this.__parentFormId) {
			RxEventEmitter.emit(this.getExternalEventName(this.__parentFormId), data);
		}
	}

	emitEventToThisForm(data: EventArgs.IMessageReceivedEventArgs) {
		RxEventEmitter.emit(this.getInternalEventName(), data);
	}

	openApplicationItem(args: IOpenApplicationItemArgs) {
		this.emit('dispatchAction', {
			type: FormsActionTypes.OPEN_APPLICATION_ITEM,
			payload: args.id
		});
	}

	// Execute Action Methods : Start

	createForm(args: ICreateFormArgs, controlId?: string) {
		this.emit('system:ExecuteAction', {
			typeName: 'CreateFormArgs',
			args,
			projectName: this.projectName,
			endPoint: this.serviceUrl,
			controlId
		} as IExecuteActionArgs<ICreateFormArgs>);
	}

	openForm(args: IOpenFormArgs, controlId?: string) {
		this.emit('system:ExecuteAction', {
			typeName: 'OpenFormArgs',
			args,
			projectName: this.projectName,
			endPoint: this.serviceUrl,
			controlId
		} as IExecuteActionArgs<IOpenFormArgs>);
	}

	openSelectionForm(args: IOpenSelectionFormArgs, controlId: string, title: IDictionary<string>) {
		if (mobile().any() && this.__mobileFormView !== Mobile.MobileFormView.WebView) {
			Mobile.MobileView.executeSelectionForm({
				formPanelId: this.__windowId,
				gridId: controlId,
				options: args.options,
				title
			});
		}

		const clonedArgs: IOpenSelectionFormArgs = cloneDeep(args);

		clonedArgs.dataSource?.parameters?.forEach(param => {
			if (param.valueModifier === 'fieldSelection') {
				const fieldValue = _get(this, param.field.split('.'), null);
				param.value = getValueControl(this, param.field.split('.')[0], fieldValue);
				param.valueModifier = 'valueEntry';
			}
		});

		const control = this.items.get(controlId);
		const rows = control?.properties.get('rows') || [];
		this.emit('system:ExecuteAction', {
			typeName: 'OpenSelectionFormArgs',
			args: clonedArgs,
			projectName: this.projectName,
			endPoint: this.serviceUrl,
			controlId,
			extendedArgs: { rows, title: title }
		} as IExecuteActionArgs<IOpenSelectionFormArgs>);
	}

	startAProcess(args: IStartAProcessArgs, controlId?: string) {
		this.emit('system:ExecuteAction', {
			typeName: 'StartAProcessArgs',
			args,
			projectName: this.projectName,
			endPoint: this.serviceUrl,
			controlId
		} as IExecuteActionArgs<IStartAProcessArgs>);
	}

	openProcess(args: IOpenProcessArgs, controlId?: string) {
		this.emit('system:ExecuteAction', {
			typeName: 'OpenProcessArgs',
			args,
			projectName: this.projectName,
			endPoint: this.serviceUrl,
			controlId
		} as IExecuteActionArgs<IOpenProcessArgs>);
	}

	// Execute Action Methods : End

	// Show Message Methods : Start

	showMessage(
		title: string | IDictionary<string>,
		text: string | IDictionary<string>,
		type: 'Success' | 'Error' | 'Warning' | 'Info' | 'Validation' | 'SevereWarning' | 'Blocked',
		highlightList?: string[]
	) {
		const message: any = {
			typeName: 'ShowMessageAction',
			dialogType: 'Popup',
			alertType: type,
			id: createGuid(),
			messages: text,
			name: title,
			enabled: true
		};
		Mobile.MobileView.mobileClientSideMessages([message]);
		FormsHelpers.showPopupMessage(
			title,
			type,
			text,
			highlightList,
			this.__windowId,
			this.activeView
		);
		this.__onShowMessage?.('MessageBox', {
			title,
			type,
			text,
			highlightList,
			windowId: this.__windowId
		});
	}

	showToaster(
		title: string | IDictionary<string>,
		text: string | IDictionary<string>,
		type: 'Success' | 'Error' | 'Warning' | 'Info' | 'Validation' | 'SevereWarning' | 'Blocked',
		highlightList?: string[]
	) {
		const message: any = {
			typeName: 'ShowMessageAction',
			dialogType: 'Toaster',
			alertType: type,
			id: createGuid(),
			messages: text,
			name: title,
			enabled: true
		};
		Mobile.MobileView.mobileClientSideMessages([message]);
		FormsHelpers.showToasterMessage(
			title,
			type,
			text,
			highlightList,
			this.__windowId,
			this.activeView
		);
		this.__onShowMessage?.('Toaster', {
			title,
			type,
			text,
			highlightList,
			windowId: this.__windowId
		});
	}

	showConfirm(title: string | IDictionary<string>, text: string | IDictionary<string>) {
		if (this.isMobile() && this.__mobileFormView === Mobile.MobileFormView.NativePlus) {
			return Mobile.MobileView.showNotification({
				id: createGuid(),
				type: 'confirm',
				title: MLHelper.getMLText(title),
				content: MLHelper.getMLText(text)
			});
		}

		return FormsHelpers.showConfirm(title, text);
	}

	// Show Message Methods : End

	openExternalLink(url: string) {
		if (this.isMobile()) {
			Mobile.MobileView.onHTMLTextBoxLinkClick(url);
		} else {
			window.open(url);
		}
	}

	saveForm(keepPanelOpen?: boolean) {
		this.__keepPanelOpen = keepPanelOpen;
		this.__saveForm({ key: 'toolbarSaveButton' });
	}

	closeForm() {
		this.__closeWindowById && this.__closeWindowById();
	}

	getIconHTML(name: string) {
		require(`@bimser/icons/16/${name}.js`);
		return `<svg><use xlink:href='#16_${name}.svg'/></svg>`;
	}

	isMobile() {
		return this.__fromMobile;
	}

	__handleToolbarButtonClick(toolbarItem: any) {
		if (this.__fromMobile && this.__mobileFormView === Mobile.MobileFormView.NativePlus) {
			const item = this.toolbarButtons.find(button => button.key === toolbarItem?.key);
			if (item) {
				this.__onToolbarButtonClicked(item);
			}
		} else {
			this.__onToolbarButtonClicked(toolbarItem);
		}
	}

	__onToolbarButtonClicked(item: any) {
		if (
			Object.keys(this.__pendingServerEvent.requests).length ||
			this.controls.find(control => Object.keys(control.__pendingServerEvent.requests).length)
		) {
			return BCNotification.warning({ message: findMessage.get('102463') });
		}

		switch (item?.key) {
			case 'toolbarSaveButton': {
				this.__saveForm(item);
				break;
			}
			case 'toolbarSaveAsButton': {
				this.__saveAsForm(item);
				break;
			}
			case 'toolbarPrintButton': {
				this.__printForm();
				break;
			}
			case 'toolbarOkButton': {
				this.__returnChildForm(false, item);
				break;
			}
			case 'toolbarSaveAsDraftButton': {
				this.__saveAsDraft();
				break;
			}
		}

		if (!['toolbarSaveButton', 'toolbarOkButton', 'toolbarSaveAsButton'].includes(item?.key)) {
			const argument: IToolbarButtonClickEventArgs = { name: item?.name };
			const toolbarButton = this.toolbarButtons?.find(button => button.key === item.key);

			this.emit('event:OnToolbarButtonClicked', { ...argument, key: item?.key }).then(() => {
				if (toolbarButton.validate && this.__validateRelatedDocumentFiles()) {
					this.emit('dispatchAction', {
						type: FormsActionTypes.CHECK_RULES,
						payload: FormsPayloadEntities.FormRuleTriggerPayloadFactory({
							windowId: this.__getWindowId(),
							rules: getTriggeredRules(this.rules, {
								controlId: this.formName,
								eventName: 'OnToolbarButtonClicked'
							}),
							validate: toolbarButton.validate,
							projectName: this.projectName,
							packageVersion: this.packageVersion
						})
					});
				}
			});
			this.emit<IUserEvent<IToolbarButtonClickEventArgs>>(
				'event:server:OnToolbarButtonClicked',
				{
					argument,
					controlId: this.name,
					name: 'OnToolbarButtonClicked',
					sender: 'web'
				}
			);
		}
	}

	showLoading() {
		if (this.__showLoading) {
			this.__showLoading();
		}
	}

	hideLoading() {
		if (this.__hideLoading) {
			this.__hideLoading();
		}
	}

	toggleLoading() {
		if (this.loading) {
			if (this.__hideLoading) {
				this.__hideLoading();
			}
		} else {
			if (this.__showLoading) {
				this.__showLoading();
			}
		}
	}

	__saveAsDraft() {
		if (this.readOnly) {
			BCNotification.warning({
				message: findMessage.get('100652'),
				description: findMessage.get('102257')
			});
			return false;
		}

		const mergedData = mergeDataAndView(this.items, this.view);
		const request: any = {
			secretKey: this.draftSecretKey || this.secretKey,
			form: {
				data: normalizeItemsForServer(mergedData.toJS())
			},
			starterInfo: {
				type: this.flowSecretKey ? 1 : 0,
				flowSecretKey: this.flowSecretKey
			}
		};
		this.emit('system:OnBeforeSaveAsDraft', null);
		SaveAsDraft({
			formName: this.formName,
			projectName: this.projectName,
			requestParameters: request
		})
			.then((response: any) => {
				if (response.data?.status == FormsEntities.IFormStatus.Completed) {
					this.emit('system:OnAfterSaveAsDraft', true);
					this.emit('dispatchAction', {
						type: FormsActionTypes.FORM_SAVED_AS_DRAFT_SAGA,
						payload: {
							documentId: response.data.documentId,
							secretKey: response.data.secretKey,
							windowId: this.__windowId
						}
					});

					BCNotification.success({ message: findMessage.get('102674') });
					this.draftSecretKey = response.data.secretKey;
					Mobile.MobileView.mobileServiceResponse(
						true,
						'SaveAsDraft',
						JSON.stringify({ formPanelId: this.__windowId })
					);
				} else {
					this.emit('system:OnAfterSaveAsDraft', false);
					BCNotification.warning({ message: findMessage.get('102675') });
					const toasterContent: any = {
						typeName: 'ShowMessageAction',
						dialogType: 'Toaster',
						alertType: 'Warning',
						id: createGuid(),
						messages: request.content,
						name: request.title,
						enabled: true
					};
					Mobile.MobileView.mobileClientSideMessages([toasterContent]);
				}
			})
			.catch((err: any) => {
				this.emit('system:OnAfterSaveAsDraft', false);
				BCNotification.error({
					message: findMessage.get('102513'),
					description: findMessage.get('102676')
				});
				Mobile.MobileView.mobileServiceResponse(false, 'SaveAsDraft', JSON.stringify(err));
			})
			.finally(() => {
				Mobile.MobileView.toggleLoading(false);
			});
	}

	sendDataEntryForm() {
		this.__returnChildForm(false, { key: 'toolbarOkButton', name: 'Tamam' });
	}

	__returnChildForm(isSaving?: boolean, toolbarItem?: any, data?: any) {
		const returnDataAndCloseWindow = () => {
			const eventArgs: IDictionary<any> = { extraProps: { serverArgs: {}, clientArgs: {} } };

			const onUnloadArgs: IUnloadEventArgs = { cancelClose: false };

			this.emit<IUserEvent<{}>>('event:server:OnUnload', {
				argument: {
					extraProps: {}
				},
				controlId: this.name,
				name: 'OnUnload',
				sender: 'web',
				guid: createGuid()
			})
				.then(() => {
					eventArgs.extraProps.serverArgs =
						this.__executedServerEvent?.parameters?.extraProps || {};
				})
				.catch(err => {
					console.log(`An error occurred on ${this.name} event:server:OnUnload `, err);
				})
				.finally(() => {
					this.emit('event:OnUnload', onUnloadArgs)
						.then(extraProps => {
							eventArgs.extraProps.clientArgs = extraProps[0];
						})
						.finally(() => {
							const argument: IToolbarButtonClickEventArgs = {
								name: toolbarItem?.name
							};
							const info = data
								? {
										documentId: data.documentId,
										processId: data.processId,
										requestId: data.requestId
								  }
								: {};

							this.emitEventToParent({
								type: 'RETURN_CHILD_FORM_DATA',
								data: { ...eventArgs, ...info }
							});
							this.emitEventToThisForm({
								type: 'RETURN_CHILD_FORM_DATA',
								data: eventArgs
							});
							this.emit('event:OnToolbarButtonClicked', {
								...argument,
								key: toolbarItem?.key
							});
							this.emit<IUserEvent<IToolbarButtonClickEventArgs>>(
								'event:server:OnToolbarButtonClicked',
								{
									argument,
									controlId: this.name,
									name: 'OnToolbarButtonClicked',
									sender: 'web'
								}
							).finally(() => {
								if (this.__parentFormId) {
									this.applyChanges().then(() => {
										if (!onUnloadArgs.cancelClose && !this.__keepPanelOpen) {
											this.emit('dispatchAction', {
												type: FormsActionTypes.CLOSE_WINDOW_AFTER_SAVE,
												payload:
													FormsEntities.CloseWindowAfterSavePayloadFactoryFromJS(
														{ windowId: this.__windowId }
													)
											});
										}
									});
								}
							});
						});
				});
		};

		const validate = this.__validateModalForm || isNullOrUndefined(this.__validateModalForm);
		const isValid: boolean = this.__validateRelatedDocumentFiles();

		if (validate && !isSaving && isValid) {
			if (!RxEventEmitter.subjects['$checkRules_' + this.__windowId]) {
				RxEventEmitter.listen('checkRules_' + this.__windowId, {
					next: (data: any) => {
						if (
							data.type === 'CHECK_RULES_RESULT' &&
							data.windowId === this.__windowId &&
							!data.result
						) {
							returnDataAndCloseWindow();
						}
					}
				});
			}

			this.emit('dispatchAction', {
				type: FormsActionTypes.CHECK_RULES,
				payload: FormsPayloadEntities.FormRuleTriggerPayloadFactory({
					windowId: this.__getWindowId(),
					rules: getTriggeredRules(this.rules, {
						controlId: this.formName,
						eventName: 'OnToolbarButtonClicked'
					}),
					validate: validate,
					projectName: this.projectName
				})
			});
		} else if (this.__parentFormId) {
			returnDataAndCloseWindow();
		}
	}

	__saveForm(item: any) {
		if (this.readOnly) {
			BCNotification.warning({
				message: findMessage.get('100652'),
				description: findMessage.get('102257')
			});
			return false;
		}

		this.showLoading();

		const beforeSaveArgs: IBeforeSaveEventArgs = {
			cancel: false,
			triggerKey: item.key
		};

		this.emit('event:OnBeforeCommit', {});
		this.emit('event:OnBeforeSave', beforeSaveArgs)
			.then(response => {
				const canHideLoading = !(
					this.__isFlowEventForm &&
					this.__fromMobile &&
					this.__mobileFormView === Mobile.MobileFormView.NativePlus
				);

				if (!beforeSaveArgs.cancel) {
					this.applyChanges().then(() => {
						const toolbarSaveButton = this.toolbarButtons?.find(
							button => button.key === 'toolbarSaveButton'
						);
						let isValid: boolean = true;
						if (toolbarSaveButton.validate) {
							isValid = this.__validateRelatedDocumentFiles();
						}
						if (isValid) {
							const mergedData = mergeDataAndView(this.items, this.view);
							let payload: FormsEntities.FormSavePayload =
								FormsEntities.FormSavePayloadFactoryFromJS({
									items: mergedData.entities.items.toJS() as IDictionary<LayoutCreatorEntities.ILayoutStructureItem>,
									requestData: {
										documentId: this.documentId,
										formName: this.formName,
										projectName: this.projectName,
										formData: mergedData.toJS(),
										secretKey: toolbarSaveButton?.secretKey || this.secretKey
									},
									onAfterSave: (status, secretKey) => {
										this.__OnAfterSave(status, secretKey, item);
										this.__onActionForm(
											mergedData.entities.items.toJS() as IDictionary<LayoutCreatorEntities.ILayoutItem>
										);

										if (canHideLoading) {
											this.hideLoading();
										}
									},
									rules: {},
									validate: toolbarSaveButton.validate
								});

							payload = payload.set(
								'rules',
								getTriggeredRules(this.rules, {
									controlId: this.formName,
									eventName: 'OnBeforeSave'
								})
							);
							this.emit('event:OnFormSave', payload);
						} else {
							this.hideLoading();
						}
					});
				} else {
					console.log('Form save process canceled.', beforeSaveArgs);
					this.hideLoading();
				}
			})
			.catch(() => {
				this.hideLoading();
			});
	}

	__saveAsForm(item: any) {
		if (this.readOnly) {
			BCNotification.warning({
				message: findMessage.get('100652'),
				description: findMessage.get('102257')
			});
			return false;
		}

		this.showLoading();

		const beforeSaveAsArgs: IBeforeSaveAsEventArgs = {
			cancel: false,
			triggerKey: item.key
		};

		this.emit('event:OnBeforeCommit', {});

		this.emit<IUserEvent<IBeforeCommitEventArgs>>('event:server:OnBeforeCommit', {
			argument: {},
			controlId: this.name,
			name: 'OnBeforeCommit',
			sender: 'web',
			guid: createGuid()
		});

		this.emit('event:OnBeforeSaveAs', beforeSaveAsArgs)
			.then(() => {
				if (!beforeSaveAsArgs.cancel) {
					this.applyChanges().then(() => {
						const toolbarSaveAsButton = this.toolbarButtons?.find(
							button => button.key === 'toolbarSaveAsButton'
						);
						let isValid: boolean = true;
						if (toolbarSaveAsButton.validate) {
							isValid = this.__validateRelatedDocumentFiles();
						}
						if (isValid) {
							const mergedData = mergeDataAndView(this.items, this.view);
							let payload: FormsEntities.FormSaveAsPayload =
								FormsEntities.FormSaveAsPayloadFactoryFromJS({
									items: mergedData.entities.items.toJS() as IDictionary<LayoutCreatorEntities.ILayoutStructureItem>,
									requestData: {
										documentId: this.documentId,
										formName: this.formName,
										projectName: this.projectName,
										formData: mergedData.toJS(),
										secretKey: toolbarSaveAsButton?.secretKey || this.secretKey
									},
									onAfterSaveAs: (status, secretKey) => {
										this.__OnAfterSave(status, secretKey, item);
										this.hideLoading();
									},
									rules: {},
									validate: toolbarSaveAsButton.validate
								});

							payload = payload.set(
								'rules',
								getTriggeredRules(this.rules, {
									controlId: this.formName,
									eventName: 'OnBeforeSave'
								})
							);

							this.emit('event:OnFormSaveAs', payload);
						} else {
							this.hideLoading();
						}
					});
				} else {
					console.log('Form save as process canceled.', beforeSaveAsArgs);
					this.hideLoading();
				}
			})
			.catch(() => {
				this.hideLoading();
			});
	}

	__printForm() {
		if (mobile().any()) {
			return this.showToaster(
				findMessage.get('100652'),
				findMessage.get('103242'),
				'Warning'
			);
		}

		const printBtn: IFormToolbarPrintButton = this.toolbarButtons.find(
			i => i.key === 'toolbarPrintButton'
		);

		if (printBtn) {
			if (printBtn.isServerPrint) {
				this.__runServerEvent({
					argument: { printButton: printBtn.name },
					controlId: this.name,
					name: 'OnPrinting',
					sender: 'web'
				});

				return;
			}

			this.__beforePrint().then(() => {
				this.__printRef.handlePrint();
			});
		}
	}

	__printServerForm() {
		this.__serverFormDomRef.current.form.applyChanges().then(() => {
			this.__beforeServerPrint();
			this.__serverPrintRef.current.handlePrint();
		});
	}

	__renderServerPrint() {
		const printBtn: IFormToolbarPrintButton = this.toolbarButtons.find(
			i => i.key === 'toolbarPrintButton'
		);
		const serverPrintFormProperties = this.__getServerPrintFormProperties?.();

		if (printBtn?.isServerPrint && serverPrintFormProperties) {
			return (
				<>
					<ReactToPrint
						ref={this.__serverPrintRef}
						content={() => {
							const shadowRoot =
								this.__serverFormDomRef.current.form.__getShadowRoot();

							if (shadowRoot) {
								const container = document.createElement('div');
								container.appendChild(shadowRoot);
								return container;
							} else {
								return this.__serverFormDomRef.current.form.layoutCreatorRefs
									.current?.container;
							}
						}}
						documentTitle={this.formName || ''}
						onAfterPrint={this.__afterServerPrint}
						onPrintError={this.__afterServerPrint}
						copyStyles
						removeAfterPrint
					/>
					<FormView
						{...serverPrintFormProperties}
						ref={this.__serverFormDomRef}
						formReadyForPrint={this.__printServerForm}
						activeView={printBtn.view}
						mediaScreen
					/>
				</>
			);
		}
	}

	__onAfterSaveAndContinue(data: EventArgs.IAfterEventSentArgs) {
		if (data.windowId === this.__windowId) {
			this.__OnAfterSave(data.status, null, null, data);
			this.emit('event:OnAfterEventSent', data);
		}
	}

	__OnAfterSave(
		status: FormsEntities.IFormStatus,
		secretKey: string,
		toolbarItem?: any,
		data?: any
	) {
		if (secretKey) {
			this.secretKey = secretKey;
		}
		switch (status) {
			case FormsEntities.IFormStatus.Completed: {
				this.emit('event:OnAfterSave', {});
				this.emit('event:OnCommit', {});
				this.__returnChildForm(true, toolbarItem, data);

				const control = this.controls.find(x => x.name === this.relatedControlId);
				if (
					this.relatedControlId &&
					(isNullOrUndefined(control) ||
						control.controlType !== FormItemTypes.EControlTypes.Lookup)
				) {
					this.__triggerRelatedItemDataChange();
				}

				break;
			}
			case FormsEntities.IFormStatus.Canceled:
			case FormsEntities.IFormStatus.ValidationError: {
				this.emit('event:OnRollback', {});
				break;
			}
		}
	}

	__onActionForm(payload: IDictionary<LayoutCreatorEntities.ILayoutItem>) {
		const formProperties = payload[this.formName].properties;
		if (formProperties.formType !== 'action') {
			return;
		}
		const title = payload.txtTitle?.properties.multiLanguageText;
		const description = payload.txtDescription?.properties.multiLanguageText;
		const startDate = payload.dtStartDate?.properties.value;
		const endDate = payload.dtEndDate?.properties.value;
		const assignto = payload.cmbAssign?.properties.selectedItemValues[0];
		const stateId = +payload.cmbState?.properties.selectedItemValues[0];
		const priority = payload.nbPriority?.properties.value;
		const tags = payload.tbTags?.properties.selectedItemValues
			.filter(t => payload.tbTags?.properties.items.findIndex(i => i.value == t) > -1)
			.join(',');
		const documentId = this.documentId;

		const request = {
			title,
			description,
			startDate,
			endDate,
			assignto,
			stateId,
			priority,
			tags,
			documentId
		};
		if (this.documentId > 0) {
			RxEventEmitter.emit(this.getExternalEventName(), {
				type: 'actionFormUpdated',
				payload: request
			});
			return;
		}
		try {
			ServiceList.Studio.Action.CreateAction.callPromise(request).then(response => {
				if (response) {
					RxEventEmitter.emit(this.getExternalEventName(), {
						type: 'actionFormCreated',
						payload: { request, windowId: this.__windowId }
					});
					BCNotification.success({ message: findMessage.get('102930') });
					const closePayload: FormsEntities.CloseWindowAfterSavePayload =
						FormsEntities.CloseWindowAfterSavePayloadFactoryFromJS({
							windowId: this.__windowId
						});
					this.emit('dispatchAction', {
						type: FormsActionTypes.CLOSE_WINDOW_AFTER_SAVE,
						payload: closePayload
					});
				}
			});
		} catch (error) {
			console.log('ActionForm ~ error', error);
		}
	}

	__validateRelatedDocumentFiles(validate?: boolean) {
		let isValid = true;

		this.items.forEach(i => {
			if (i.type === FormItemTypes.EControlTypes.RelatedDocuments && isValid) {
				const fileDescriptionIsRequired = i.properties.get('fileDescriptionIsRequired');
				const files: Array<IRelatedDocumentFile> = i.properties.get('files');
				const categories = i.properties.get('categories');

				if (fileDescriptionIsRequired && files) {
					isValid = files.find(file => !file.description) ? false : true;

					if (!isValid) {
						BCNotification.error({
							message: findMessage.get('100567'),
							description: findMessage.get('100378')
						});
						const message: any = {
							typeName: 'ShowMessageAction',
							dialogType: 'Toaster',
							alertType: 'Error',
							id: createGuid(),
							messages: findMessage.get('100378'),
							name: findMessage.get('100567'),
							enabled: true
						};
						Mobile.MobileView.mobileClientSideMessages([message]);
					}
				}

				if (categories && isValid) {
					isValid = this.__validateRDCategories(i);
				}
			}
		});

		if (!isValid) {
			Mobile.MobileView.toggleLoading(false);
		}

		return isValid;
	}

	private __validateRDCategories(i: LayoutCreatorEntities.LayoutItem) {
		const caption = i.properties.get('caption');
		const controlCaption = MLHelper.getMLText(caption.text);
		const categories = i.properties.get('categories');
		const files: Array<IRelatedDocumentFile> = i.properties.get('files');
		let isValid = true;

		categories.forEach((v: IRelatedDocumentCategory) => {
			const categoryName = MLHelper.getMLText(v.name);
			if (files && v.enabled) {
				const filesByCategory = files.filter(t => t.category.id === v.id);
				if (
					!filesByCategory ||
					(filesByCategory &&
						!isNullOrUndefined(v.minFilesCount) &&
						v.minFilesCount > filesByCategory.length)
				) {
					BCNotification.error({
						message: findMessage.get('100567'),
						description: findMessage
							.get('102387')
							.replace('$1', controlCaption)
							.replace('$2', categoryName)
							.replace('$3', String(v.minFilesCount))
					});
					const message: any = {
						typeName: 'ShowMessageAction',
						dialogType: 'Toaster',
						alertType: 'Warning',
						id: createGuid(),
						messages: findMessage
							.get('102387')
							.replace('$1', controlCaption)
							.replace('$2', categoryName)
							.replace('$3', String(v.minFilesCount)),
						name: findMessage.get('100652'),
						enabled: true
					};
					Mobile.MobileView.mobileClientSideMessages([message]);
					isValid = false;
				}
			} else if (v.minFilesCount !== 0 && v.enabled) {
				BCNotification.error({
					message: findMessage.get('100567'),
					description: findMessage
						.get('102387')
						.replace('$1', controlCaption)
						.replace('$2', categoryName)
						.replace('$3', String(v.minFilesCount))
				});
				const message: any = {
					typeName: 'ShowMessageAction',
					dialogType: 'Toaster',
					alertType: 'Warning',
					id: createGuid(),
					messages: findMessage
						.get('102387')
						.replace('$1', controlCaption)
						.replace('$2', categoryName)
						.replace('$3', String(v.minFilesCount)),
					name: findMessage.get('100652'),
					enabled: true
				};
				Mobile.MobileView.mobileClientSideMessages([message]);
				isValid = false;
			}
		});

		return isValid;
	}

	__triggerRelatedItemDataChange() {
		const data: FormsEntities.RelatedDataChangeAction =
			FormsEntities.RelatedDataChangeActionFactoryFromJS({
				windowId: this.__windowId,
				documentId: this.documentId,
				relatedControlId: this.relatedControlId,
				parentFormId: this.__parentFormId,
				executeActionType: this.executeActionType
			});

		if (!this.__form.relatedControlId) {
			const closePayload: FormsEntities.CloseWindowAfterSavePayload =
				FormsEntities.CloseWindowAfterSavePayloadFactoryFromJS({
					windowId: this.__windowId
				});
			this.emit('dispatchAction', {
				type: FormsActionTypes.CLOSE_WINDOW_AFTER_SAVE,
				payload: closePayload
			});
		}

		window.setTimeout(() => {
			this.emitEventToParent({
				data,
				type: FormsActionTypes.RELATED_ITEM_DATA_CHANGE
			});
		}, 500); // Panel maximized ise event rx subscription ların panel kapandıktan sonra parent üzerinde ayağa kalkmasını beklemek için eklenmiştir.
	}

	__onEventButtonClicked(event: any) {
		let isValid = true;
		if (event.validate) {
			isValid = this.__validateRelatedDocumentFiles();
		}

		if (isValid) {
			const beforeSaveArgs: IBeforeSaveEventArgs = {
				cancel: false,
				triggerKey: event.id
			};

			if (!this.hasSubscriber('event:OnBeforeSave')) {
				this.emit('dispatchAction', {
					type: FormsActionTypes.ON_BEFORE_FORM_SAVE_RESPONSE,
					payload: {
						eventEmitter: true,
						windowId: this.__windowId,
						result: true,
						secretKey: this.secretKey,
						viewName: this.activeView,
						documentId: this.documentId
					}
				});
			}

			this.emit('event:OnBeforeSave', beforeSaveArgs).then(response => {
				if (!beforeSaveArgs.cancel) {
					this.emit('dispatchAction', {
						type: FormsActionTypes.ON_BEFORE_FORM_SAVE_RESPONSE,
						payload: {
							eventEmitter: true,
							windowId: this.__windowId,
							result: true,
							secretKey: this.secretKey,
							viewName: this.activeView,
							documentId: this.documentId
						}
					});
				} else {
					console.log('Form save process canceled.', beforeSaveArgs);
					this.emit('dispatchAction', {
						type: FormsActionTypes.ON_BEFORE_FORM_SAVE_RESPONSE,
						payload: {
							eventEmitter: true,
							windowId: this.__windowId,
							result: false,
							secretKey: this.secretKey,
							viewName: this.activeView,
							documentId: this.documentId
						}
					});
				}
			});
		} else {
			this.emit('dispatchAction', {
				type: FormsActionTypes.ON_BEFORE_FORM_SAVE_RESPONSE,
				payload: {
					eventEmitter: true,
					windowId: this.__windowId,
					result: false,
					secretKey: this.secretKey,
					viewName: this.activeView,
					documentId: this.documentId
				}
			});
		}
	}

	__onLayoutDidUpdate() {
		if (!this.__isInitialized) {
			this.emit('event:OnLoad', {});
		}
		this.isFirstLoad = false;
	}

	increasePendingPropertyCount(transactionId: string) {
		this.__transactions[transactionId].pendingPropertyChangeCount++;
	}

	decreasePendingPropertyCount(transactionId: string) {
		this.__transactions[transactionId].pendingPropertyChangeCount--;
	}

	setTransactionChangingStatus(transactionId: string, status: boolean) {
		this.__transactions[transactionId].isChanging = status;
	}

	applyChanges() {
		return new Promise<void>((resolve, reject) => {
			setTimeout(() => {
				const awaitPromises: Promise<void>[] = [];

				Object.keys(this.__transactions).forEach(transactionId => {
					if (!this.__transactions[transactionId].isChanging) {
						const promise = this.endTransaction(transactionId);
						awaitPromises.push(promise);
					}
				});

				Promise.all(awaitPromises)
					.then(() => {
						resolve();
					})
					.catch(() => {
						reject();
					});
			}, 10);
		});
	}

	beginTransaction(options?: { timeout: number; autoDispatchTimeout: number }) {
		options = options || { timeout: 3000, autoDispatchTimeout: 0 };

		this.__transactionId = createGuid();
		if (!this.__transactions[this.__transactionId]) {
			const transaction: ITransaction = {
				id: this.__transactionId,
				changedProperties: [],
				pendingPropertyChangeCount: 0,
				isDispatched: false,
				isChanging: true,
				promise: null,
				timer: {
					timeout: null,
					autoDispatch: null
				},
				...options
			};
			this.__transactions[this.__transactionId] = transaction;

			if (options.timeout) {
				transaction.timer.timeout = window.setTimeout(() => {
					this.endTransaction(transaction.id);
				}, options.timeout);
			}

			if (options.autoDispatchTimeout) {
				transaction.timer.autoDispatch = window.setTimeout(() => {
					this.endTransaction(transaction.id);
				}, options.autoDispatchTimeout);
			}
		}
		return this.__transactionId;
	}

	endTransaction(transactionId?: string) {
		const tempTransctionId = transactionId || this.__transactionId;

		const currentPromise = this.__transactions[tempTransctionId]?.promise;
		if (currentPromise) {
			return currentPromise;
		}

		const promise = new Promise<void>(resolve => {
			const fn = (endTransactionGuid: string) => {
				if (!this.__transactions[tempTransctionId]?.isDispatched) {
					return;
				}
				const selfIndex = this.__sentTransactions.indexOf(tempTransctionId);
				const updatedIndex = this.__sentTransactions.indexOf(endTransactionGuid);

				if (selfIndex === -1) {
					this.off('system:transactionEnd', fn);
					delete this.__transactions[tempTransctionId];

					resolve();
				} else if (selfIndex <= updatedIndex) {
					this.__sentTransactions.splice(selfIndex, 1);
					this.off('system:transactionEnd', fn);
					delete this.__transactions[tempTransctionId];
					resolve();
				}
			};
			this.subscribe('system:transactionEnd', fn);
		});

		if (this.__transactions[tempTransctionId]) {
			this.__transactions[tempTransctionId].promise = promise;
		}
		this.__transactionId = null;

		if (this.__transactions[tempTransctionId]?.pendingPropertyChangeCount === 0) {
			this.__dispatchChangedProperties(tempTransctionId);
			this.__sentTransactions.push(tempTransctionId);
			if (!this.__transactions[tempTransctionId].changedProperties.length) {
				this.emit('system:transactionEnd', tempTransctionId);
			}
		} else {
			const fn = (scope: FormsEntities.IPropertyChangeTransaction) => {
				if (
					scope.transactionId === tempTransctionId &&
					this.__transactions[scope.transactionId]?.pendingPropertyChangeCount <= 0
				) {
					this.off('system:PropertyChangePerformed', fn);
					const changeCount =
						this.__transactions[scope.transactionId].changedProperties.length;
					if (changeCount > 0) {
						this.__dispatchChangedProperties(scope.transactionId);
					}
					this.__sentTransactions.push(scope.transactionId);
					if (changeCount == 0) {
						this.__transactions[scope.transactionId].isDispatched = true;
						this.emit('system:transactionEnd', scope.transactionId);
					}
				}
			};
			this.subscribe('system:PropertyChangePerformed', fn);
		}

		return promise;
	}

	__dispatchChangedProperties(transactionId: string) {
		const transaction = this.__transactions[transactionId];

		window.clearTimeout(transaction.timer.autoDispatch);
		window.clearTimeout(transaction.timer.timeout);
		transaction.timer.autoDispatch = null;
		transaction.timer.timeout = null;

		transaction.isDispatched = true;
		if (!transaction.changedProperties?.length) {
			return;
		}

		const data = [...transaction.changedProperties];

		const awaitPreRenderPromises: Promise<any>[] = [];
		const argsData: FormsEntities.IPropertyChangeTransaction = {
			data: [],
			transactionId: transactionId
		};

		data.forEach(change => {
			awaitPreRenderPromises.push(
				this.__triggerPreRender(change.args.id, change.args.dataField, change.args.value)
			);
			argsData.data.push(change.args);
			if (this.__formViewerControlType) {
				argsData[
					'windowId'
				] = `${this.__formViewerFormId}_${this.__formViewerControlType}_${this.__formViewerControlName}_${this.__formViewerViewName}_${this.documentId}`;
			}
		});

		Promise.all(awaitPreRenderPromises).then(() => {
			this.emit('system:PropertyChanged', argsData).then(() => {
				data.forEach(item => item.resolver());
				this.controls.forEach(c => {
					(this as any)[c.name]?.__controlsUpdated(argsData.data);
				});
			});
		});
	}

	__onPropertyChanged(scope: FormsEntities.IPropertyChangeTransaction) {
		return new Promise<void>(resolver => {
			let transaction = this.__transactions[scope.transactionId];
			if (!transaction) {
				const tId = this.beginTransaction({
					autoDispatchTimeout: 0,
					timeout: 300
				});
				transaction = this.__transactions[tId];
			}

			if (transaction.timer.autoDispatch) {
				window.clearTimeout(transaction.timer.autoDispatch);
			}

			transaction.changedProperties.push({ args: scope.data[0], resolver });

			if (transaction.autoDispatchTimeout) {
				transaction.timer.autoDispatch = window.setTimeout(() => {
					this.endTransaction(transaction.id);
				}, transaction.autoDispatchTimeout);
			}
		});
	}

	__OnEventActionEvent(event: any) {
		const eventActionEventArgs: IEventActionEventArgs = {
			id: event.Id,
			description: event.Description,
			sourceType: 'flow'
		};

		this.emit('event:OnEventAction', eventActionEventArgs);
	}

	__loadProperties(data: IFormProperties) {
		super.__loadProperties(data);

		if (data.view !== undefined) {
			this.view = data.view;
		}
		if (data.items !== undefined) {
			this.items = data.items;
		}
		if (data.windowSize !== undefined) {
			if (!this.windowSize.equals(data.windowSize) && data.windowSize.width) {
				this.__onFormResize();
				this.windowSize = data.windowSize;
			}
		}

		this.__proxyChanged.text = data.text;
		this.__proxyChanged.formType = data.formType;
		this.__proxyChanged.sizeType = data.sizeType;
		this.__proxyChanged.paddingType = data.paddingType;
		this.__proxyChanged.statuses = data.statuses;
		this.__proxyChanged.identityFormat = data.identityFormat;
		this.__proxyChanged.identityFormatId = data.identityFormatId;
		this.__proxyChanged.copyPasteEnabled = data.copyPasteEnabled;
		this.__proxyChanged.toolbarButtons = data.toolbarButtons;
		this.__proxyChanged.publicFields = data.publicFields;
		this.__proxyChanged.versioningEnabled = data.versioningEnabled;
		this.__proxyChanged.session = data.session;
		this.__proxyChanged.activeView = data.activeView;
		this.__proxyChanged.responseParameters = data.responseParameters;
		this.__proxyChanged.rules = data.rules;
		this.__proxyChanged.canSaveAsDraft = data.canSaveAsDraft;
	}

	__getItems() {
		return new Promise<{
			items: LayoutCreatorEntities.NormalizedLayoutItems;
			response: FormsEntities.IFormResponse;
			structureItems: LayoutCreatorEntities.NormalizedLayoutStructureItems;
			dataItems: Map<string, LayoutCreatorEntities.LayoutDataItem>;
		}>((resolve, reject) => {
			if (this.isFirstLoad) {
				CreateForm({
					projectName: this.projectName,
					formName: this.formName,
					documentId: this.documentId ? this.documentId : 0,
					secretKey: this.createSecretKey || null,
					projectVersion: this.packageVersion
				})
					.then((response: any) => {
						const { responseData, structureItems, dataItems } =
							this.__parseCreateFormResponse(response.data);
						if (responseData.form.data) {
							resolve({
								items: LayoutCreatorEntities.NormalizedLayoutItemsFactoryFromJS(
									FormsHelpers.showServerSideMessages(responseData.form.data)
								),
								response: responseData,
								structureItems,
								dataItems
							});
							const hasActiveView =
								responseData.form.data.entities.items?.[this.formName]?.properties
									?.activeView;

							if (hasActiveView && responseData.secretKey) {
								this.emit('dispatchAction', {
									type: FormsActionTypes.FORM_UPDATE_SECRET_KEY_SAGA,
									payload: {
										documentId: this.documentId,
										secretKey: responseData.secretKey,
										windowId: this.__windowId,
										view: hasActiveView
									}
								});
							}
						}
					})
					.catch(error => {
						this.__formCaptionTextChanged(this.formName);
						this.__formError = error.exception.data;
						reject(error);
					});
			} else {
				reject();
			}
		});
	}

	private __parseCreateFormResponse(_responseData: FormsEntities.IFormResponse) {
		this.secretKey = _responseData.secretKey;
		this.draftSecretKey = this.secretKey;
		const responseData: FormsEntities.IFormResponse = _responseData; //Response dan dönen cevaba bakılacak.
		if (this.isDataEntryForm) {
			responseData.form.data.entities.items[this.formName].properties.toolbarButtons = [
				{
					DefaultEnabled: true,
					caption: findMessage.getAsMultiLanguageObject('100004'),
					enabled: true,
					icon: 'ok',
					key: 'toolbarOkButton',
					name: 'Tamam',
					validate: this.__validateModalForm
				} as any
			];
		} else if (
			(this.flowSecretKey
				? this.canSaveAsDraft
				: responseData.form.data.entities.items[this.formName].properties.canSaveAsDraft) &&
			!this.readOnly
		) {
			responseData.form.data.entities.items[this.formName].properties.toolbarButtons.push({
				caption: findMessage.getAsMultiLanguageObject('102513'),
				enabled: true,
				icon: 'save-as',
				key: 'toolbarSaveAsDraftButton',
				name: 'SaveAsDraft'
			});
		}

		const { structureItems, dataItems } = ViewerHelpers.splitDataAndStructureItems(
			responseData.form.data
		);

		return { responseData, structureItems, dataItems };
	}

	__parseMobileFormResponse(formData: LayoutCreatorEntities.INormalizedLayoutItems) {
		if (this.isDataEntryForm) {
			formData.entities.items[this.formName].properties.toolbarButtons = [
				{
					DefaultEnabled: true,
					caption: findMessage.getAsMultiLanguageObject('100004'),
					enabled: true,
					icon: 'ok',
					key: 'toolbarOkButton',
					name: 'Tamam',
					validate: this.__validateModalForm
				} as any
			];
		} else if (
			(this.flowSecretKey
				? this.canSaveAsDraft
				: formData.entities.items[this.formName].properties.canSaveAsDraft) &&
			!this.readOnly
		) {
			formData.entities.items[this.formName].properties.toolbarButtons.push({
				caption: findMessage.getAsMultiLanguageObject('102513'),
				enabled: true,
				icon: 'save-as',
				key: 'toolbarSaveAsDraftButton',
				name: 'SaveAsDraft'
			});
		}

		const { structureItems, dataItems } = ViewerHelpers.splitDataAndStructureItems(formData);

		return { structureItems, dataItems };
	}

	__updateFormData(formData) {
		const { structureItems, dataItems } = ViewerHelpers.splitDataAndStructureItems(formData);
		this.items = dataItems;
		this.view = structureItems;
		this.__createControls();
	}

	private __checkRules(eventItem: IRuleTriggerEventItem) {
		if (
			eventItem.controlId === this.name &&
			(eventItem.eventName === 'OnBeforeSave' ||
				eventItem.eventName === 'OnToolbarButtonClicked')
		) {
			return;
		}

		this.emit('checkRules', {
			rules: getTriggeredRules(this.rules, eventItem),
			windowId: this.__getWindowId()
		});
	}

	__clearUnknownControls() {
		if (this.controlMap && Object.keys(this.controlMap)?.length) {
			Object.keys(this.controlMap).forEach(controlKey => {
				const currentItems = this.view?.entities?.items;
				const currentGhostItems = this.view?.entities?.ghostItems;
				if (currentItems?.count() || currentGhostItems?.count()) {
					const itemExist =
						currentItems?.has(controlKey) || currentGhostItems?.has(controlKey);
					if (!itemExist) {
						delete this.controlMap[controlKey];
						delete (this as any)[controlKey];
					}
				} else {
					this.controlMap = {};
				}
			});
		}
	}

	__subscribeClientEvents(item: LayoutCreatorEntities.LayoutItem, control: Control) {
		let clientEvents: IEventItem[] = [];
		if (item.properties?.get('clientEvents')) {
			clientEvents = item.properties.get('clientEvents');
		}
		if (!clientEvents?.length) {
			return false;
		}
		clientEvents?.forEach((event: IEventItem) => {
			if (!(this as any)[event.methodName]) {
				return false;
			}

			const $this = this;

			const call = async function (args: any) {
				const fn = ($this as any)[event.methodName].bind(($this as any)[$this.name])(args);
				if (fn instanceof Promise) {
					try {
						return await fn;
					} catch (error) {
						console.log(`An Error Occurred on ${event.methodName}`, error.message);
					}
				}
			};

			if (item.type === FormItemTypes.EContainerTypes.Form) {
				this.subscribe(`event:${event.name}`, call);
			} else {
				control.subscribe(`event:${event.name}`, call);
			}
		});
	}

	__subscribeServerEvents(item: LayoutCreatorEntities.LayoutItem, control: Control) {
		if (item.properties?.get('serverEvents')) {
			const serverEvents: IEventItem[] = item.properties.get('serverEvents');

			if (serverEvents?.length) {
				serverEvents.forEach((event: IEventItem) => {
					const run = (args: any) =>
						this.__runServerEvent(args, event.async).then(arg => {
							this.__executedServerEvent = arg.executedServerEvent;

							if (arg.loadActionData.isDMFileSecretModified) {
								this.__loadDocumentViewer();
							}

							if (arg.loadActionData.isRDFileSecretModified) {
								this.isLoadingRDObjects = false;
								this.__getRDObjects();
							}
						});

					control.subscribe(`event:server:${event.name}`, run.bind(this));
				});
			}
		}
	}

	private __createControl(
		item: LayoutCreatorEntities.LayoutItem,
		ruleClientTriggerEvents: IRuleTriggerEventItem[],
		ruleServerTriggerEvents: IRuleTriggerEventItem[]
	) {
		let control = this.controlMap[item.id];
		if (!control) {
			// Create new control instance
			control = FormItemManager.getFormItemInstance(
				item.type,
				this.isMobile() && this.__mobileFormView === Mobile.MobileFormView.NativePlus
			);
			if (item.type === FormItemTypes.EContainerTypes.Form) {
				control = this as Control;
			} else {
				control.subscribe('system:PropertyChanged', this.__onPropertyChanged.bind(this));
			}

			// Define control id
			control.name = item.id;
			if (item.type === FormItemTypes.EContainerTypes.Form) {
				this.name = item.id;
			}

			// Assign form variable to all controls
			control.__form = this;
			control.__beginInitialize();

			// Subscribe Global property change event
			if (item.type !== FormItemTypes.EContainerTypes.Form) {
				control.subscribe(
					`event:OnPropertyChanged`,
					(args: IPropertyChangedEventArgs<any>) => {
						const propertyChangedArgs: IPropertyChangedEventArgs<any> = {
							...args,
							controlName: control.name
						};
						this.emit('event:OnPropertyChanged', propertyChangedArgs);
					}
				);
			}

			// Assign control variable to controlMap
			this.controlMap[item.id] = control;
			// Assign control as proxy to Form
			(this as any)[item.id] = proxyCreator(control, control.__triggerPropertyChanging);

			// Subscribe client events
			this.__subscribeClientEvents(item, control);
			// Subscribe server events
			this.__subscribeServerEvents(item, control);
			// Subscribe Rule Trigger Events
			this.__subscribeRuleTriggers(
				control,
				ruleClientTriggerEvents,
				ruleServerTriggerEvents,
				item
			);
			// Push to Controls
			this.controls.push(control);
		}
	}

	__subscribeRuleTriggers(
		control: Control,
		ruleClientTriggerEvents: IRuleTriggerEventItem[],
		ruleServerTriggerEvents: IRuleTriggerEventItem[],
		item: LayoutCreatorEntities.LayoutItem
	) {
		const ruleClientEvents = _uniqWith(
			ruleClientTriggerEvents.filter(i => i.controlId === control.name),
			_isEqual
		);

		if (control) {
			ruleClientEvents.forEach((ruleEvent: IRuleTriggerEventItem) => {
				const eventFn = () => {
					this.__checkRules(ruleEvent);
				};

				if (control.controlType === FormItemTypes.EContainerTypes.Form) {
					this.subscribe(`event:${ruleEvent.eventName}`, eventFn);
				} else {
					control.subscribe(`event:${ruleEvent.eventName}`, eventFn);
				}
			});

			const ruleServerEvents = _uniqWith(
				ruleServerTriggerEvents.filter(i => i.controlId === control.name),
				_isEqual
			);
			let serverEvents: IEventItem[] = [];

			if (item.properties?.get('serverEvents')) {
				serverEvents = item.properties.get('serverEvents');
			}

			ruleServerEvents.forEach((ruleEvent: IRuleTriggerEventItem) => {
				const run = (args: any) =>
					this.__runServerEvent(args, null).then(arg => {
						this.__executedServerEvent = arg.executedServerEvent;

						if (arg.loadActionData.isDMFileSecretModified) {
							this.__loadDocumentViewer();
						}

						if (arg.loadActionData.isRDFileSecretModified) {
							this.isLoadingRDObjects = false;
							this.__getRDObjects();
						}
					});

				let isServerEventSubscribed = null;
				if (serverEvents?.length) {
					isServerEventSubscribed = serverEvents.find(
						(event: IEventItem) => event.name === ruleEvent.eventName
					);
				}

				if (
					control.controlType === FormItemTypes.EContainerTypes.Form &&
					!isServerEventSubscribed
				) {
					this.subscribe(`event:server:${ruleEvent.eventName}`, run.bind(this));
				} else if (!isServerEventSubscribed) {
					control.subscribe(`event:server:${ruleEvent.eventName}`, run.bind(this));
				}
			});
		}
	}

	__validate(): Promise<boolean> {
		return new Promise<boolean>(resolve => {
			this.emit('event:OnValidating', null).then(([result]) => {
				if (!isNullOrUndefined(result) && !result) {
					return resolve(false);
				}
				return resolve(true);
			});
		});
	}

	__runServerEvent(data: IUserEvent<any>, async?: boolean, toolbarSecretKey?: string) {
		const context: any = this;
		let delay = 1000;

		return new Promise<{
			loadActionData: LayoutCreatorEntities.IFormItemsLoadAction;
			executedServerEvent: IControlExecutedServerEvent;
		}>(resolve => {
			if (data) {
				if (data.name === 'Click' || data.runImmediately) {
					delay = 0;
				}

				if (context.__pendingServerEvent.changeTimeout) {
					window.clearTimeout(context.__pendingServerEvent.changeTimeout);
				}

				context.__pendingServerEvent.requests[`${data.controlId}_${data.name}`] = {
					data,
					resolve
				};

				const done = () => {
					window.clearTimeout(context.__pendingServerEvent.changeTimeout);
					context.__pendingServerEvent.changeTimeout = null;

					Object.keys({ ...context.__pendingServerEvent.requests }).forEach(eventName => {
						let { data: userEvent, resolve: mainResolve } =
							context.__pendingServerEvent.requests[eventName];
						if (userEvent && Object.keys(userEvent).length === 0) {
							userEvent = null;
						}

						const createTask = () =>
							new Promise((rslv, reject) => {
								this.applyChanges().then(() => {
									context.showLoading();
									let showReadOnly = false;
									if (!context.readOnly) {
										context.__proxyChanging.readOnly = true;
										showReadOnly = true;
									}

									const mergedData = mergeDataAndView(
										context.items,
										context.view
									);

									RunEvent<any>(context.projectName, context.formName, {
										secretKey:
											toolbarSecretKey ||
											context.secretKey ||
											context.runSecretKey,
										form: { data: normalizeItemsForServer(mergedData.toJS()) },
										formId: 0,
										userEvent
									})
										.then(response => {
											rslv({
												response,
												guid: 'RunEvent_' + createGuid(),
												baseResolve: mainResolve,
												readOnly: showReadOnly,
												userEventName: userEvent.name
											});
										})
										.catch(error => {
											if (error?.exception?.data) {
												context.hideLoading();
												context.__runEventPending = false;
												context.__proxyChanging.readOnly = false;
												MessageBox.error({
													error: (error.exception as any).data
												});
											}
											reject();
										});
								});
							});

						const resolveRunEvent = ({
							response,
							guid,
							baseResolve,
							readOnly,
							userEventName
						}: {
							response: any;
							guid: string;
							baseResolve: (response: any) => void;
							readOnly: boolean;
							userEventName: string;
						}) => {
							if (response?.data?.form?.data) {
								const responseData: FormsEntities.IFormResponse = response.data;
								const responseItems: LayoutCreatorEntities.INormalizedLayoutItems =
									responseData.form.data;
								context.secretKey = responseData.secretKey;

								const hasActiveView =
									responseData.form.data.entities.items?.[this.formName]
										?.properties?.activeView;

								if (hasActiveView && responseData.secretKey) {
									this.emit('dispatchAction', {
										type: FormsActionTypes.FORM_UPDATE_SECRET_KEY_SAGA,
										payload: {
											documentId: this.documentId,
											secretKey: responseData.secretKey,
											windowId: this.__windowId,
											view: hasActiveView
										}
									});
								}

								const rules = getTriggeredRules((context as any).rules, {
									controlId: this.name,
									eventName: 'OnLoad'
								}).toJS() as IDictionary<IRuleType>;
								const formItem = responseItems.entities.items[this.name];
								const isPrintEvent =
									formItem?.properties?.executedServerEvents?.find(
										(event: any) => event.name === 'OnPrinting'
									);
								const closeForm = formItem?.properties?.executedServerEvents?.find(
									(event: any) => event.name === 'CloseForm'
								);
								closeForm && this.closeForm();

								if (readOnly) {
									_set(
										responseItems.entities.items,
										[this.name, 'properties', 'readOnly'],
										false
									);
								}

								let executedServerEvent: IControlExecutedServerEvent;
								const responseControl =
									responseItems.entities.items[data.controlId];
								if (responseControl?.properties) {
									const executedServerEvents: IControlExecutedServerEvent[] =
										responseControl.properties.executedServerEvents;
									executedServerEvent = executedServerEvents?.find(
										e => e.name === userEventName
									);
									responseControl.properties.executedServerEvents = [];
								}

								if (isPrintEvent) {
									const loadServerPrintFormItems = () => {
										const mergedData = mergeDataAndView(
											context.items,
											context.view
										).toJS();
										const mergedItems = deepMergeFormItems(
											mergedData,
											responseItems,
											this.__form.__windowId
										);
										const { structureItems, dataItems } =
											ViewerHelpers.splitDataAndStructureItems(mergedItems);

										const loadActionData: LayoutCreatorEntities.IFormItemsLoadAction =
											{
												formId: isPrintEvent
													? `${context.__windowId}_ServerPrint`
													: context.__windowId,
												items: isPrintEvent ? mergedItems : mergedData,
												dataItems:
													dataItems.toJS() as IDictionary<LayoutCreatorEntities.ILayoutDataItem>,
												structureItems: structureItems.toJS(),
												rules,
												secretKey: context.secretKey,
												runSecretKey: context.runSecretKey,
												lastBatchGuid: guid,
												isDMFileSecretModified: isDMSecretModified(
													responseItems,
													mergedData,
													FormItemTypes.EControlTypes.DocumentViewer
												),
												isRDFileSecretModified: isDMSecretModified(
													responseItems,
													mergedData,
													FormItemTypes.EControlTypes.RelatedDocuments
												),
												documentId: this.documentId
											};

										context.__formItemsLoaded(loadActionData);
									};

									const loadCurrentFormItems = () => {
										const mergedData = mergeDataAndView(
											context.items,
											context.view
										).toJS();
										const { structureItems, dataItems } =
											ViewerHelpers.splitDataAndStructureItems(mergedData);

										const loadActionData: LayoutCreatorEntities.IFormItemsLoadAction =
											{
												formId: context.__windowId,
												items: mergedData,
												dataItems:
													dataItems.toJS() as IDictionary<LayoutCreatorEntities.ILayoutDataItem>,
												structureItems: structureItems.toJS(),
												rules,
												secretKey: context.secretKey,
												runSecretKey: context.runSecretKey,
												lastBatchGuid: guid,
												isDMFileSecretModified: isDMSecretModified(
													responseItems,
													mergedData,
													FormItemTypes.EControlTypes.DocumentViewer
												),
												isRDFileSecretModified: isDMSecretModified(
													responseItems,
													mergedData,
													FormItemTypes.EControlTypes.RelatedDocuments
												),
												documentId: this.documentId
											};

										context.__formItemsLoaded(loadActionData);

										if (
											!Object.keys(context.__pendingServerEvent.requests)
												.length
										) {
											this.hideLoading();
										}

										baseResolve({ loadActionData, executedServerEvent });
									};

									loadServerPrintFormItems();
									loadCurrentFormItems();
								} else {
									const mergedData = mergeDataAndView(
										context.items,
										context.view
									).toJS();
									const mergedItems = deepMergeFormItems(
										mergedData,
										responseItems,
										this.__form.__windowId
									);
									const { structureItems, dataItems } =
										ViewerHelpers.splitDataAndStructureItems(mergedItems);

									const loadActionData: LayoutCreatorEntities.IFormItemsLoadAction =
										{
											formId: context.__windowId,
											items: mergedItems,
											dataItems:
												dataItems.toJS() as IDictionary<LayoutCreatorEntities.ILayoutDataItem>,
											structureItems: structureItems.toJS(),
											rules,
											secretKey: context.secretKey,
											runSecretKey: context.runSecretKey,
											lastBatchGuid: guid,
											isDMFileSecretModified: isDMSecretModified(
												responseItems,
												mergedData,
												FormItemTypes.EControlTypes.DocumentViewer
											),
											isRDFileSecretModified: isDMSecretModified(
												responseItems,
												mergedData,
												FormItemTypes.EControlTypes.RelatedDocuments
											),
											documentId: this.documentId
										};

									context.__formItemsLoaded(loadActionData);

									if (
										!Object.keys(context.__pendingServerEvent.requests).length
									) {
										this.hideLoading();
									}

									baseResolve({ loadActionData, executedServerEvent });
								}
							}
						};

						if (async) {
							// Asenkron olarak direkt çalıştır
							createTask().then((response: IRunTaskResponse) => {
								resolveRunEvent(response);
							});
						} else {
							// Async değilse eventi sıraya alır
							this.__createQueue(createTask).then((response: IRunTaskResponse) => {
								resolveRunEvent(response);
							});
						}
					});

					context.__pendingServerEvent.requests = {};
				};

				context.__pendingServerEvent.changeTimeout = window.setTimeout(done, delay);
			}
		});
	}

	__createControls() {
		this.__clearUnknownControls();

		const ruleClientTriggerEvents: IRuleTriggerEventItem[] = [];
		const ruleServerTriggerEvents: IRuleTriggerEventItem[] = [];

		if (!this.items || this.items.isEmpty()) {
			return false;
		}

		// GENERATE TO RULE TRIGGER EVENTS
		const formItem = this.items.find(i => i.type === FormItemTypes.EContainerTypes.Form);
		const formViewItem = this.view.entities.items.find(
			i => i.type === FormItemTypes.EContainerTypes.Form
		);

		const formProperties: IFormProperties = formItem.properties.toJS() as any;

		const rules = formProperties.rules;

		for (const i in rules) {
			if (!rules[i].triggerEvents) {
				continue;
			}
			rules[i].triggerEvents.forEach(eventPath => {
				const eventPathArr = eventPath.split('.');
				if (eventPathArr[1] === 'client') {
					ruleClientTriggerEvents.push({
						controlId: eventPathArr[0],
						eventName: eventPathArr[2]
					});
				} else if (eventPathArr[1] === 'server') {
					ruleServerTriggerEvents.push({
						controlId: eventPathArr[0],
						eventName: eventPathArr[2]
					});
				}
			});
		}

		// GENERATE TO RULE TRIGGER EVENTS : END

		// Initialize form and load its properties in advance

		this.initialize();
		this.__loadProperties(formProperties);
		this.__createControl(formItem, ruleClientTriggerEvents, ruleServerTriggerEvents);

		const normalizedItems = setPanelChildren(formViewItem, this.view);
		this.controlMap[formItem.id].__loadChildren(
			normalizedItems as LayoutCreatorEntities.NormalizedLayoutStructureItems
		);

		this.view.entities.items.forEach(viewItem => {
			const dataItem = this.items?.get(viewItem.id);
			if (dataItem && viewItem && viewItem.id !== formItem.id) {
				this.__createControl(dataItem, ruleClientTriggerEvents, ruleServerTriggerEvents);

				const panelNormalizedItems = setPanelChildren(viewItem, this.view);
				this.controlMap[viewItem.id].__loadChildren(
					panelNormalizedItems as LayoutCreatorEntities.NormalizedLayoutStructureItems
				);
			}
		});

		this.view.entities.ghostItems.forEach(viewItem => {
			const dataItem = this.items?.get(viewItem.id);
			if (dataItem && viewItem && viewItem.id !== formItem.id) {
				this.__createControl(dataItem, ruleClientTriggerEvents, ruleServerTriggerEvents);
			}
		});

		this.controls.forEach(control => {
			if (!control.__isInitialized) {
				control.emit('event:OnInit', {});
				control.emit('event:OnPreRender', {});

				if (control.controlType !== FormItemTypes.EContainerTypes.Form) {
					control.initialize();
				}
			}
		});

		this.__runLoadProperties();

		this.__getRDObjects();
		this.__triggerOnLoadEvents();
		this.__reloadControlDataSource();

		this.controls.forEach(control => {
			control.__endInitialize();
		});
		this.__endInitialize();
	}

	__runLoadProperties() {
		this.__form.items.forEach(item => this.__loadControlProperties(item));
	}

	__loadDocumentViewer() {
		this.__form.items.forEach(item => {
			if (item.type === FormItemTypes.EControlTypes.DocumentViewer) {
				this.controlMap[item.id].__onLoad();
			}
		});
	}

	private __loadControlProperties(item: LayoutCreatorEntities.LayoutItem) {
		const properties: IControlProperties = (item.properties?.toJS() || item.properties) as any;
		if (properties && this.controlMap[item.id]) {
			this.controlMap[item.id].__loadProperties(properties);
			if (item.type === FormItemTypes.EContainerTypes.Form) {
				this.__onFormCaptionTextChange(properties as IFormProperties);
			}
		}
	}

	__reloadControlDataSource() {
		this.items.forEach(item => {
			let properties;
			let control;

			if (FormItemTypes.EControlTypes[item.type as FormItemTypes.EControlTypes]) {
				properties = item.properties?.toJS?.();
				control = this.controlMap[item.id];
			}

			let dataSource: IDataSource;

			if (properties && control) {
				dataSource = properties.dataSource;
			}
			if (dataSource?.parameters?.length) {
				this.applyChanges().then(() => {
					control.__reloadDataSource(dataSource, false, true).catch(() => {
						// Do nothing...
					});
				});
			}
		});
	}

	__triggerOnLoadEvents() {
		this.controls.forEach(control => {
			if (control.__isInitialized) {
				return false;
			}
			if (control.controlType !== FormItemTypes.EContainerTypes.Form) {
				control.emit('event:OnLoad', {}); // Trigger Control OnLoad Events
			}
		});

		if (!this.__isInitialized) {
			this.emit('event:OnLoad', {}); // Trigger Form OnLoad Event
		}
	}

	__onFormCaptionTextChange(properties: IFormProperties) {
		let title = properties.caption.text
			? geti18nValue(properties.caption.text, this.currentLanguage)
			: '';
		if (!title.length) {
			title = geti18nValue(properties.caption.text, MLHelper.defaultLanguage);
		}
		if (title && title !== this.__currentFormCaption) {
			this.__currentFormCaption = title;
			if (this.__formCaptionTextChanged) {
				this.__formCaptionTextChanged(title);
			}
		}
	}

	__getRDObjects() {
		if (
			this.__form.displayMode == 'execution' &&
			(!this.isLoadingRDObjects || this.rdObjectLoadedForView !== this.activeView)
		) {
			const rdSecretKeys = [];

			this.items
				.filter(i => i.type == FormItemTypes.EControlTypes.RelatedDocuments)
				.forEach(i => {
					const targetData = i.properties.get('targetSecretKey');
					if (targetData && !rdSecretKeys.includes(targetData)) {
						rdSecretKeys.push(targetData);
					}

					if (i.properties.get('files')) {
						i.properties.get('files').forEach((file: IRelatedDocumentFile) => {
							const fileData = file.secretKey;
							if (!_isEmpty(fileData) && !rdSecretKeys.includes(fileData)) {
								rdSecretKeys.push(fileData);
							}
						});
					}

					if (i.properties.get('categories')) {
						i.properties
							.get('categories')
							.forEach((category: IRelatedDocumentCategory) => {
								const categoryData = category.targetSecretKey;
								if (
									!_isEmpty(categoryData) &&
									!rdSecretKeys.includes(categoryData)
								) {
									rdSecretKeys.push(categoryData);
								}
							});
					}
				});

			this.items
				.filter(i => i.type == FormItemTypes.EControlTypes.FileSelector)
				.forEach(i => {
					const uploadTarget = i.properties.get('uploadTargetSecretKey');

					if (uploadTarget) {
						rdSecretKeys.push(uploadTarget);
					}

					i.properties.get('files')?.forEach((f: IFile) => {
						const fileData = f.secretKey;
						rdSecretKeys.push(fileData);
					});
				});

			this.__getRelatedDocumentObjects(rdSecretKeys);
		}
	}

	private __getRelatedDocumentObjects(rdSecretKeys: string[]) {
		if (!rdSecretKeys.length) {
			return;
		}

		this.controls.forEach(control => {
			if (
				control.controlType == FormItemTypes.EControlTypes.RelatedDocuments ||
				control.controlType == FormItemTypes.EControlTypes.FileSelector
			) {
				control.__triggerPropertyChanging(true, ['loading']);
			}
		});

		this.isLoadingRDObjects = true;
		this.rdObjectLoadedForView = this.activeView;

		GetRelatedDocumentObjects({
			projectName: this.projectName,
			formName: this.formName,
			parameters: {
				objectRequestSecretKeys: rdSecretKeys
			},
			packageVersion: this.packageVersion
		})
			.then(response => {
				const objects: any[] = response.data.objects;
				if (objects) {
					this.controls.forEach(control => {
						if (control.controlType == FormItemTypes.EControlTypes.RelatedDocuments) {
							const targetSecretKey = objects.find(
								o => o.id == (control as RelatedDocuments).targetId
							)?.secretKey;
							const files = (control as RelatedDocuments).files.map(f => {
								const fileObj = objects.find(o => o.id.toString() == f.id);
								if (fileObj) {
									f.name = MLHelper.getMLText(fileObj.name);
									f.creator = fileObj.creator;
									f.extension = f.name.split('.').pop();
									f.secretKey = fileObj.secretKey;
									f.createDate = fileObj.createdAt;
									f.path = fileObj.path;
								}
								return f;
							});

							const categories = (control as RelatedDocuments).categories.map(c => {
								if (c.targetId) {
									const fileObj = objects.find(
										o => o.id.toString() == c.targetId
									);
									if (fileObj) {
										c.targetSecretKey = fileObj.secretKey;
									}
								}
								return c;
							});

							control.__triggerPropertyChanging(targetSecretKey, ['targetSecretKey']);
							control.__triggerPropertyChanging(files, ['files']);
							control.__triggerPropertyChanging(categories, ['categories']);
							control.__triggerPropertyChanging(false, ['loading']);
						} else if (
							control.controlType == FormItemTypes.EControlTypes.FileSelector
						) {
							const uploadTargetSecretKey: string = objects.find(
								(o: any) => o.id == (control as FileSelector).uploadTargetId
							)?.secretKey;
							const selectionTarget: IDmData = objects.find(
								(o: any) => o.id == (control as FileSelector).selectionTargetId
							);
							const files = (control as FileSelector).files.map(f => {
								const fileObj: IDmData = objects.find(o => o.id.toString() == f.id);
								if (fileObj) {
									f.path = fileObj.path;
									f.secretKey = fileObj.secretKey;
									f.name = MLHelper.getMLText(fileObj.name);
								}
								return f;
							});

							(control as FileSelector).__uploadTargetSecretKey =
								uploadTargetSecretKey;
							(control as FileSelector).__selectionTarget = selectionTarget;
							control.__triggerPropertyChanging(files, ['files']);
							control.__triggerPropertyChanging(false, ['loading']);
						}
					});
					Mobile.MobileView.getRelatedDocumentObjects(response);
				} else {
					BCNotification.error({ message: findMessage.get('102428') });
				}
			})
			.catch(() => {
				BCNotification.error({ message: findMessage.get('102428') });
			});
	}

	async __triggerPreRender(id: string, dataField?: string[], changedValue?: any) {
		const awaitPromises: Promise<any>[] = [];

		for (const control of this.controls) {
			if (control.name === id) {
				const currentProperty = _get(control, dataField);
				const isChangeProperty =
					dataField?.length &&
					JSON.stringify(currentProperty) !== JSON.stringify(changedValue);

				if (isChangeProperty || !dataField.length) {
					const controlPreRenderPromise = control.emit('event:OnPreRender', {});
					awaitPromises.push(controlPreRenderPromise);
				}
			}
		}

		return Promise.all(awaitPromises);
	}

	__controlRenderManager(id: string, children?: JSX.Element) {
		const control = this.controlMap[id];

		if (!control) {
			// Assume that it is a LayoutControl
			if (this.displayMode === 'preview' && children) {
				return children;
			}

			return <div>{'Undefined Component'}</div>;
		}

		const item = this.items.get(id);
		let commitId = item.getIn(['properties', 'commitId']);

		if (
			control.controlType === FormItemTypes.EControlTypes.Mirror &&
			!_isEmpty((control as Mirror).targetId)
		) {
			Object.keys(this.controlMap).forEach(key => {
				if (this.controlMap[key].controlId === (control as Mirror).targetId) {
					id = this.controlMap[key].name;
					commitId = this.items.getIn([id, 'properties', 'commitId']);
				}
			});
		}

		if (FormItemTypes.EPanelBaseTypes[this.items.get(id).type]) {
			commitId = new Date().getTime();
		}

		return (
			<ControlComponent
				id={id}
				form={this}
				windowId={this.__windowId}
				commitId={commitId}
			>
				{children}
			</ControlComponent>
		);
	}

	__isControlVisible(id: string) {
		const control = this.controlMap[id];

		if (this.displayMode == 'preview' && !control) {
			const structureControl = this.view.entities.items.get(id);
			return (
				structureControl.designerProps.layout.get('visible') &&
				structureControl.designerProps.layout.get('clientVisible')
			);
		}

		if (control instanceof VisualControl) {
			const isVisible =
				(control.visible && control.clientVisible) ||
				control.controlType === FormItemTypes.EContainerTypes.Form;
			if (!isVisible) {
				Mobile.MobileView.setControlProperties(
					control.name,
					control.__getComponentData(),
					this.__windowId || ''
				);
			}

			return isVisible;
		} else if (control instanceof LayoutControl) {
			const isVisible = control.layout.visible && control.layout.clientVisible;
			if (!isVisible) {
				Mobile.MobileView.setControlProperties(
					control.name,
					control.__getComponentData(),
					this.__windowId || ''
				);
			}

			return isVisible;
		} else if (control instanceof Mirror) {
			const targetControl = this.controls.find(c => c.controlId === control.targetId);

			if (targetControl instanceof VisualControl) {
				return targetControl.visible && targetControl.clientVisible;
			}

			return true;
		}

		return null;
	}

	__getOwnProperties() {
		return Object(Form).getOwnPropertyNames();
	}

	__getPropertyFields(properties?: Map<string, any>): IPropertyField[] {
		const fields = super.__getPropertyFields();
		const variableItems: IPropertyField[] = [];

		if (properties) {
			const variables: IDictionary<IVariableItem> = properties.get('variables');
			if (variables && Object.keys(variables).length) {
				Object.keys(variables).forEach(v => {
					variableItems.push({
						name: variables[v].name,
						type: 'number'
					});
				});
			}
		}

		return [
			...fields,
			{
				name: 'text',
				type: 'object',
				items: getCultureEnumMembers()
			},
			{
				name: 'formType',
				type: 'enum',
				enumMembers: ['modal', 'parameter', 'profile', 'standard'] as FormType[],
				readOnly: true
			},
			{
				name: 'activeView',
				type: 'string',
				readOnly: true
			},
			{
				name: 'session',
				type: 'object',
				readOnly: true,
				items: [
					{
						name: 'EncryptedData',
						type: 'string',
						readOnly: true
					},
					{
						name: 'Token',
						type: 'string',
						readOnly: true
					},
					{
						name: 'Language',
						type: 'string',
						readOnly: true
					},
					{
						name: 'HasDelegation',
						type: 'boolean',
						readOnly: true
					},
					{
						name: 'DelegationId',
						type: 'number',
						readOnly: true
					},
					{
						name: 'User',
						type: 'object',
						items: [
							{
								name: 'Department',
								type: 'object',
								items: [
									{
										name: 'Id',
										type: 'number'
									}
								]
							},
							{
								name: 'Email',
								type: 'string'
							},
							{
								name: 'FirstName',
								type: 'string'
							},
							{
								name: 'Id',
								type: 'number'
							},
							{
								name: 'InternalName',
								type: 'string'
							},
							{
								name: 'LastName',
								type: 'string'
							},
							{
								name: 'Name',
								type: 'string'
							},
							{
								name: 'Position',
								type: 'object',
								items: [
									{
										name: 'Id',
										type: 'number'
									}
								]
							},
							{
								name: 'Profession',
								type: 'object',
								items: [
									{
										name: 'Id',
										type: 'number'
									}
								]
							}
						]
					}
				]
			},
			{
				name: 'responseParameters',
				type: 'object',
				readOnly: true,
				items: [
					{
						name: 'workflowInfo',
						type: 'object',
						readOnly: true,
						items: [
							{
								name: 'currentStep',
								type: 'object',
								readOnly: true,
								items: [
									{
										name: 'key',
										type: 'string',
										readOnly: true
									},
									{
										name: 'name',
										type: 'string',
										readOnly: true
									}
								]
							},
							{
								name: 'processId',
								type: 'number',
								readOnly: true
							}
						]
					}
				]
			},
			{
				name: 'variables',
				type: 'object',
				items: variableItems,
				readOnly: true
			}
		];
	}

	/** 
        ### Caution
        #### **Only for mobile usage**
        **This function opens a mobile barcode viewer purpose of returning barcode values to form.**
    */
	openBarcodeReader() {
		return new Promise((resolve, reject) => {
			if (!this.__fromMobile) {
				this.__proxyChanging.loading = false;

				reject('This attribute only avaliable on mobile.');
			}

			const returnBarcode = (value?: string) => {
				this.__proxyChanging.loading = false;
				clearTimeout(barcodeReadingTimeout);

				if (value) {
					resolve(value);
					return;
				}

				reject('Error occured during reading the Code..');
			};

			const cameraPermissonDenied = () => {
				this.showToaster(findMessage.get('100652'), findMessage.get('102816'), 'Warning');

				this.__proxyChanging.loading = false;
				clearTimeout(barcodeReadingTimeout);

				reject(findMessage.get('102816'));
			};

			const barcodeReadingTimeout = setTimeout(() => {
				this.showToaster(findMessage.get('100652'), findMessage.get('100089'), 'Warning');
				Mobile.MobileView.closeBarcodeReader(this.name, this.__form?.__windowId || '');
				returnBarcode();
			}, 90000);

			this.__proxyChanging.loading = true;

			Mobile.MobileView.openBarcodeReader(this.name, this.__form?.__windowId || '');
			Mobile.MobileView.setFunctionForMobile(
				Mobile.MobileFunctions.SetBarcodeValue,
				(value: string) => returnBarcode(value)
			);
			Mobile.MobileView.setFunctionForMobile(
				Mobile.MobileFunctions.CameraPermissonDenied,
				() => cameraPermissonDenied()
			);
		});
	}

	__getSummaryMessages() {
		const items: LayoutCreatorEntities.ISummaryMessage[] = [];

		if (this.summaryMessages) {
			this.summaryMessages.forEach(i => {
				items.push({
					type: i.type,
					title: i.title,
					message: i.message.get(this.currentLanguage.culture)
				});
			});
		}

		return items;
	}

	__onFormScrollStart() {
		const scrollableArea =
			this.layoutCreatorRefs.current.container?.closest('.bcScrollableArea');
		scrollableArea.parentNode.dispatchEvent(new CustomEvent('scroll', { bubbles: true }));

		this.controls.forEach(control => {
			if (control.controlType !== FormItemTypes.EContainerTypes.Form) {
				control.__onFormScrollStart();
			}
		});
	}

	__onFormResize() {
		this.controls.forEach(control => {
			if (control.controlType !== FormItemTypes.EContainerTypes.Form) {
				control.__onFormResize();
			}
		});
	}

	get scrollTo() {
		return {
			top: () => {
				this.layoutCreatorRefs.current?.scrollView?.scrollTo?.({
					top: 0,
					behavior: 'instant'
				});
			},
			bottom: () => {
				this.layoutCreatorRefs.current?.scrollView?.scrollToBottom?.();
			}
		};
	}

	__beforeServerPrint() {
		const shadowRoot = this.__getShadowRoot();

		if (!shadowRoot) {
			const scrollViewRef = this.__serverFormDomRef.current.form.layoutCreatorRefs.current
				.scrollView as any;
			const scrollRefContainer = scrollViewRef?.scrollbar?.getElement?.();
			const svgDom = document.getElementById('__SVG_SPRITE_NODE__');
			scrollRefContainer.prepend(svgDom);
			scrollRefContainer.parentNode.style.position = '';
			scrollRefContainer.parentNode.parentNode.style.height = 'auto';
			scrollRefContainer.parentNode.parentNode.parentNode.style.height = 'auto';
		}
	}

	__afterServerPrint() {
		const shadowRoot = this.__getShadowRoot();

		if (!shadowRoot) {
			const scrollViewRef = this.__serverFormDomRef.current.form.layoutCreatorRefs.current
				.scrollView as any;
			const scrollRefContainer = scrollViewRef?.scrollbar?.getElement?.();

			scrollRefContainer.parentNode.style.position = 'absolute';
			scrollRefContainer.parentNode.parentNode.style.height = '100%';
			scrollRefContainer.parentNode.parentNode.parentNode.style.height = '100%';
			const svgDomBack = document.getElementById('__SVG_SPRITE_NODE__');
			document.body.prepend(svgDomBack);
		}

		this.__getServerPrintFormProperties = null;
		this.__closeFormById(`${this.__windowId}_ServerPrint`);
	}

	__beforePrint() {
		const shadowRoot = this.__getShadowRoot();

		if (!shadowRoot) {
			const scrollViewRef = this.layoutCreatorRefs.current.scrollView as any;
			const scrollRefContainer = scrollViewRef.scrollbar.getElement();

			const svgDom = document.getElementById('__SVG_SPRITE_NODE__');
			scrollRefContainer.prepend(svgDom);
			scrollRefContainer.parentNode.style.position = '';
			scrollRefContainer.parentNode.parentNode.style.height = 'auto';
			scrollRefContainer.parentNode.parentNode.parentNode.style.height = 'auto';
		}

		const isAnyControlDirty = this.controls
			.map(control => control.__onBeforePrint())
			.some(i => i);

		if (isAnyControlDirty) {
			// Wait for the UI to update
			return new Promise(resolve => setTimeout(resolve, 200));
		}

		return Promise.resolve();
	}

	__afterPrint() {
		const shadowRoot = this.__getShadowRoot();

		if (!shadowRoot) {
			const scrollViewRef = this.layoutCreatorRefs.current.scrollView as any;
			const scrollRefContainer = scrollViewRef?.container?.firstChild?.firstChild || null;

			scrollRefContainer.parentNode.style.position = 'absolute';
			scrollRefContainer.parentNode.parentNode.style.height = '100%';
			scrollRefContainer.parentNode.parentNode.parentNode.style.height = '100%';
			const svgDomBack = document.getElementById('__SVG_SPRITE_NODE__');
			document.body.prepend(svgDomBack);
		}

		this.controls.forEach(control => control.__onAfterPrint());
	}

	__renderPrint() {
		const hasPrintBtn = this.toolbarButtons.some(i => i.key === 'toolbarPrintButton');
		if (hasPrintBtn) {
			return (
				<ReactToPrint
					ref={el => (this.__printRef = el)}
					content={() => {
						const shadowRoot = this.__getShadowRoot();

						if (shadowRoot) {
							const container = document.createElement('div');
							container.appendChild(shadowRoot);
							return container;
						} else {
							return this.layoutCreatorRefs.current.container;
						}
					}}
					documentTitle={this.formName || ''}
					onAfterPrint={this.__afterPrint}
					onPrintError={this.__afterPrint}
					copyStyles
					removeAfterPrint
				/>
			);
		}
	}

	getMenuParameters() {
		return this.responseParameters;
	}

	__renderError() {
		if (this.__formError) {
			return (
				<div>
					<BCAlert
						type={IAlertTypes.error}
						message={findMessage.get('100926')}
					/>
					<BCErrorView error={this.__formError} />
				</div>
			);
		}
	}

	__getComponentData() {
		return {
			...super.__getComponentData(),
			isInitialized: this.__isInitialized
		};
	}

	__onStructureChange(args: LayoutCreatorBuilderEntities.StructureChange) {
		this.emit('system:onStructureChange', args);
	}

	__onSummaryMessageClose(key) {
		this.emit('system:onSummaryMessageClose', key);
	}

	__getContainerClassName() {
		const classList = [`CSP_form_${this.projectName}_${this.formName}`];
		if (getDeviceType(this.windowSize.width) === EDeviceTypes.ExtraSmall) {
			classList.push('__extraSmall__');
		}
		return classList.join(' ');
	}

	__getShadowRoot() {
		if (this.getShadowDomMode()) {
			const shadowRootContainer = document.getElementById(`shadowRoot_${this.__windowId}`);

			if (shadowRootContainer) {
				return shadowRootContainer.shadowRoot;
			}
		}
	}

	__getShadowRootContainer(): HTMLElement {
		const formContainerClassName = `.CSP_form_${this.projectName}_${this.formName}`;

		if (this.getShadowDomMode()) {
			const shadowRootContainer = document.getElementById(`shadowRoot_${this.__windowId}`);

			if (shadowRootContainer) {
				return (
					shadowRootContainer.shadowRoot.querySelector(formContainerClassName) ||
					shadowRootContainer.shadowRoot.querySelector('body')
				);
			}
		}

		return document.querySelector(formContainerClassName) || document.body;
	}

	__getShadowRootScrollable(): HTMLElement {
		if (this.getShadowDomMode()) {
			const shadowRootContainer = document.getElementById(`shadowRoot_${this.__windowId}`);

			if (shadowRootContainer) {
				return shadowRootContainer.shadowRoot.querySelector('body');
			}
		}

		return document.body;
	}

	__getShadowPopupContainer(id: string): HTMLElement {
		if (this.__form.getShadowDomMode()) {
			const shadowDom = document.querySelector(`#${id}_container`);
			return shadowDom?.shadowRoot?.querySelector(`#${id}`);
		}

		return document.getElementById(id);
	}

	__render(children?: JSX.Element) {
		let url: string = '';
		if (this.displayMode === 'preview' && FormSharedVariables[this.style.backgroundImage]) {
			url = `url("data:image/jpeg;base64,${
				FormSharedVariables[this.style.backgroundImage]
			}")`;
		} else {
			url = `url("${
				!isNullOrUndefined(this.serviceUrl) && this.style.backgroundImage
					? this.serviceUrl.replace('/api', '/asset' + this.style.backgroundImage)
					: ''
			}")`;
		}

		return super.__render(
			<>
				{this.__renderPrint()}
				{this.__renderServerPrint()}
				{this.__renderError()}
				<BCLayoutCreator.Viewer
					scrollId="bcScrollableFormArea"
					containerClassName={this.__getContainerClassName()}
					view={this.view}
					controlRenderManager={this.__controlRenderManager}
					isControlVisible={this.__isControlVisible}
					windowSize={this.windowSize}
					containerStyles={{ ...this.style, backgroundImage: url }}
					onClick={this.__onControlClick}
					onDoubleClick={this.__onControlDoubleClick}
					onScroll={this.__onFormScrollStart}
					ref={this.layoutCreatorRefs}
					onLayoutDidUpdate={this.__onLayoutDidUpdate}
					paddingType={this.paddingType}
					hasScrollbar={this.__hasScrollbar}
				/>
				<SummaryMessages
					messages={this.__getSummaryMessages()}
					onSummaryMessageClose={this.__onSummaryMessageClose}
				/>
			</>
		);
	}
}
